export const VIRTUAL_TOUR_URLS = {
  "198481": "https://my.matterport.com/show/?m=qNnUQPgUrQn", // Shangri-La
  "185180": "https://my.matterport.com/show/?m=GPvvBfvLH8J", // Atacama
  "185181": "https://my.matterport.com/show/?m=sEvBuYvSp6u", // Les Sources de l'Isère
  "166835": "https://my.matterport.com/show/?m=4Yq5zeUntcp", // Léa
  "166834": "https://my.matterport.com/show/?m=sLZocfGP3XA", // Morgane
  "176166": "https://my.matterport.com/show/?m=X8igHvRyLzY", // Davos
  "185182": "https://my.matterport.com/show/?m=PZKZJJvByjg", // La Grande Sassière
  "163486": "https://my.matterport.com/show/?m=jhwQAm3Kroe", // Denali
  "166796": "https://my.matterport.com/show/?m=NW4EU3FML3h", // Acajouma
  "164302": "https://my.matterport.com/show/?m=LwfXZyvkDUz", // Arosa
  "179151": "https://my.matterport.com/show/?m=cTkzaJCz8Mn", // Inuit
};

export function getVirtualTourUrl(liheId) {
  return VIRTUAL_TOUR_URLS[liheId];
}
